/* eslint-disable react/destructuring-assignment */
import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ExportToCsv } from 'export-to-csv';
import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays
} from 'date-fns';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import { createStaticRanges } from 'react-date-range/src/defaultRanges';
import * as rdrLocales from 'react-date-range/dist/locale';
import moment from 'utils/moment';
import { renderInfoForType } from '../../../utils/helpers';
import Collapsible from '../../../components/collapsible/Collapsible';
import Button from '../../../components/button/button';
import styles from './form_list.module.scss';
import Clickable from '../../../components/clickable/Clickable';
import Separator from '../../../components/separator';
import IconButton from '../../../components/iconButton';
import print from '../../../icons/exportIcon.png';


const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  startOfLast30Days: addDays(new Date(), -29),
  endOfLast30Days: endOfDay(new Date())
};

export const formatDate = date => date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

function FormsFilterList(props) {
  const { dateRange, dates } = props;
  const child = useRef();
  const { intl, data } = props;
  const { formatMessage } = intl;
  const [stateRange, handleSelecteRange] = useState({
    selectionRange: {
      startDate: new Date(props.dates[0]),
      endDate: new Date(props.dates[1]),
      key: 'selection',
      value: 0
    }
  });

  const [dateTitle, handleTitle] = useState(
    new Date().toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  );
  const [actionPopup, setActionPopup] = useState(false);
  const [showActions] = useState(false);
  const exportData = [];
  if (data && data?.length> 0) {
    data.forEach(((item) => {
      exportData.push({
        'FORM#': item?.enable_auto_gen_as_form_id
          ? item?.auto_gen
            ?? `${moment(item?.form_date).format('YY')} - ${
              item?.order_number
            }`
          : `${moment(item?.form_date).format('YY')} - ${
              item?.order_number
            }`,
        'CREATED BY': item?.created_by?.fullname,
        'DATE': renderInfoForType({ type: 'datetime' }, item.created_at, null, null),
        'FORM NAME': item?.title,
        'FORM CATEGORY': item?.category || '',
        'WEATHER CONDITIONS': item?.weather_conditions?.title || ''
      });
    }));
  }

  const wrapperRef = useRef(null);
  const actionsBtnRef = useRef(null);

const handleActionPopup = () => {
  setActionPopup(prev => !prev);
};

const handleClickOutside = (event) => {
  if (actionPopup && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
    setActionPopup(false);
  }
};

useEffect(() => {
  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  useEffect(() => {
    if (dateRange) {
      handleTitle(dateRange);
      return;
    }
    if (dates[0]) {
      if (formatDate(new Date(dates[0])) === formatDate(new Date(dates[1]))) {
        handleTitle(`${formatDate(new Date(dates[0]))}`);
        return;
      }
      handleTitle(
        `${formatDate(new Date(dates[0]))} -  ${formatDate(new Date(dates[1]))}`
      );
    }
  }, [dateRange, dates]);

  const { selectionRange } = stateRange;

  const handleDateChange = (ranges) => {
    handleSelecteRange({
      selectionRange: {
        startDate: ranges.selection.startDate,
        endDate: ranges.selection.endDate,
        key: 'selection',
        value: ranges.selection.value
      }
    });
  };

  const equalDates = (d1, d2) => d1.getFullYear() === d2.getFullYear()
    && d1.getDate() === d2.getDate()
    && d1.getMonth() === d2.getMonth();

  const applyFilters = () => {
    const { onDateChange } = props;
    const {
      selectionRange: { startDate, endDate }
    } = stateRange;
    const selectedDateRange = document.getElementsByClassName(
      'rdrStaticRange rdrStaticRangeSelected'
    )[0];
    let rangeName;
    if (selectedDateRange) {
      rangeName = selectedDateRange.childNodes[0].textContent;
    } else {
      const sd = formatDate(startDate);
      const ed = formatDate(endDate);
      if (equalDates(startDate, endDate)) {
        rangeName = sd;
      } else {
        rangeName = `${sd} -  ${ed}`;
      }
    }
    handleTitle(rangeName);

    onDateChange(
      startDate,
      endDate,
      selectedDateRange && selectedDateRange.childNodes[0].textContent
    );
    child.current.onItemClick();
  };

  const staticRanges = createStaticRanges([
    {
      label: <FormattedMessage id="todo.alldata" defaultMessage="All Data" />,
      range: () => ({
        startDate: new Date(0),
        endDate: new Date(moment().add(4, 'year'))
      })
    },
    {
      label: formatMessage({ id: 'todo.today' }),
      range: () => ({
        startDate: defineds.startOfToday,
        endDate: defineds.endOfToday
      })
    },
    {
      label: formatMessage({ id: 'todo.Yesterday' }),
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday
      })
    },
    {
      label: formatMessage({ id: 'todo.thisWeek' }),
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfWeek
      })
    },
    {
      label: formatMessage({ id: 'todo.LastWeek' }),
      range: () => ({
        startDate: defineds.startOfLastWeek,
        endDate: defineds.endOfLastWeek
      })
    },
    {
      label: formatMessage({ id: 'todo.ThisMonth' }),
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth
      })
    },
    {
      label: formatMessage({ id: 'todo.LastMonth' }),
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth
      })
    },
    {
      label: formatMessage({ id: 'todo.lastThirtyDays' }),
      range: () => ({
        startDate: defineds.startOfLast30Days,
        endDate: defineds.endOfLast30Days
      })
    }
  ]);
  const inputRanges = [
    {
      label: formatMessage({ id: 'todo.days up to today' }),
      range(value) {
        return {
          startDate: addDays(
            defineds.startOfToday,
            (Math.max(Number(value), 1) - 1) * -1
          ),
          endDate: defineds.endOfToday,
          value
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
        if (!range.startDate) return '∞';
        if (
          selectionRange.value === 0
          && differenceInCalendarDays(defineds.endOfToday, range.startDate) === 0
        ) return 0;
        return (
          differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1
        );
      }
    },
    {
      label: formatMessage({ id: 'todo.days starting today' }),
      range(value) {
        const today = new Date();
        return {
          startDate: today,
          endDate: addDays(today, Math.max(Number(value), 1) - 1),
          value
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
        if (!range.endDate) return '∞';
        if (selectionRange.value === 0) return 0;
        return (
          differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1
        );
      }
    }
  ];
  const language = localStorage.getItem('lang') || 'en';
  const form_start_date=localStorage.getItem('form_start');
  const form_end_date=localStorage.getItem('form_end');
  const today=new Date();
  const range = `${renderInfoForType({ type: 'datetime' }, form_start_date, null, null)}
   - ${renderInfoForType({ type: 'datetime' }, form_end_date, null, null)}`;
  const exportToExcel = () => {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      title: `Form Data (${range})`,
      useTextFile: false,
      filename: `Form_Data${renderInfoForType({ type: 'date' }, today, null, null)}`,
      useBom: true,
      useKeysAsHeaders: true
    };
    const csvExporter = new ExportToCsv(options);
      if (exportData?.length !== 0) {
        csvExporter.generateCsv(exportData);
      }
    handleActionPopup();
  };
  return (
    <div className={styles.filter}>
      <div className={styles.right}>
        <Collapsible
          dateFilter
          ref={child}
          styleClasses={styles.dateHeader}
          title={dateTitle}
        >
          <div className={styles.pickerWrapper}>
            <DateRangePicker
              ranges={[stateRange?.selectionRange]}
              onChange={handleDateChange}
              rangeColors={['rgba(58, 97, 168, 0.67)']}
              color="rgba(58, 97, 168, 0.67)"
              locale={rdrLocales[language]}
              staticRanges={staticRanges}
              inputRanges={inputRanges}
              shownDate={stateRange?.selectionRange.endDate}
              input
            />
            <Button
              onClick={applyFilters}
              translationID="inspections.filter.apply"
              defaultText="Apply"
              action="secondary"
            />
          </div>
        </Collapsible>
       {showActions
       && (
      <>
      <Separator />
        <div className={styles.myFormsExport}>
        <Clickable
          className={styles.actionsBtn}
          onClick={handleActionPopup}
          ref={actionsBtnRef}
        >
          <FormattedMessage
            id="inspections.filter.actions"
            defaultMessage="Actions"
          />
        </Clickable>

        {actionPopup && (
          <div ref={wrapperRef}>
            <ul className={`${styles.actionpopup} ${actionPopup ? styles.open : ''}`}>
              <li
                className={styles.item}
                role="presentation"
                onClick={() => {
                  exportToExcel();
                }}
              >
                   <IconButton icon={print} />
                   {' '}
                    <FormattedMessage id="wildlifelog.detail.expToExcel" defaultMessage="Export to Excel" />
              </li>
            </ul>
          </div>
          )}
        </div>
      </>)}
      </div>
    </div>
  );
}
export default injectIntl(FormsFilterList);
